import type { ConsentCategoryName } from './types';

/** All c15t categories (maps to Google Consent Mode storage types). */
export const CONSENT_CATEGORIES: Array<ConsentCategoryName> = [
  'necessary',
  'functionality',
  'experience',
  'measurement',
  'marketing',
];

/**
 * Rows in the customize UI. `experience` is omitted: toggling functionality
 * also sets experience (see useConsentController).
 */
export const COOKIE_NOTICE_CATEGORIES: Array<{
  name: ConsentCategoryName;
  labelId: string;
  locked?: boolean;
}> = [
  {
    name: 'necessary',
    labelId: 'cookie.notice.category.necessary',
    locked: true,
  },
  {
    name: 'functionality',
    labelId: 'cookie.notice.category.functionality',
  },
  {
    name: 'measurement',
    labelId: 'cookie.notice.category.measurement',
  },
  {
    name: 'marketing',
    labelId: 'cookie.notice.category.marketing',
  },
];
